import { QuestionPlanIsChangeOnlyOption as Question } from "@/components/features/items/edit/plan/_shared/ui/components/plan-attributes/is-only-change-option";

import { useDayTripPlanIsChangeOnlyOption } from "./hooks";

export const QuestionDayTripPlanIsChangeOnlyOption = () => {
	const { isChangeOnlyOption, onSetIsChangeOnlyOption } = useDayTripPlanIsChangeOnlyOption();

	return <Question isChangeOnlyOption={isChangeOnlyOption} onSetIsChangeOnlyOption={onSetIsChangeOnlyOption} />;
};

QuestionDayTripPlanIsChangeOnlyOption.displayName = "QuestionDayTripPlanIsChangeOnlyOption";
